import React from "react";

import styles from "./Question.module.scss";

export type QuestionProps = {
  no: string;
  title: string;
  value: string;
  isTeacher?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const Question: React.FC<QuestionProps> = ({
  no,
  title,
  value,
  isTeacher,
  onChange,
}) => {
  return (
    <div className={styles.question}>
      <p className={styles.title}>
        <span className={styles.no}>{no}</span>
        {title}
      </p>
      <textarea
        className={styles.textarea}
        value={value}
        placeholder={
          isTeacher
            ? "入力は生徒画面で行われます。先生画面では閲覧のみ可能です。"
            : "テキストを入力してください。"
        }
        disabled={isTeacher}
        onChange={onChange}
        maxLength={2000}
      />
    </div>
  );
};

export default Question;
